import clsx from 'clsx';
import React from 'react';
import styles from './styles.module.css';

export type RadioButtonProps = {
  checked?: boolean;
  onChange?: () => void;
};

export const RadioButton = ({ checked, onChange }: RadioButtonProps) => {
  const handleChange = () => {
    if (onChange) {
      onChange();
    }
  };

  const checkedCircle = clsx({
    [styles.circle]: checked,
  });

  return (
    <div className={styles.radioContainer}>
      <label className={styles.radioLabel}>
        <input
          type="checkbox"
          className={styles.radioInput}
          checked={checked}
          onChange={handleChange}
        />
        <div className={styles.radioCircle}>
          <div className={checkedCircle} />
        </div>
      </label>
    </div>
  );
};
